import React from 'react';
import { toastr } from 'react-redux-toastr';
import { connect } from 'react-redux';
import { FormGroup, FormControl, FormLabel } from "react-bootstrap";
import { IoMdColorFill } from "react-icons/io";
import { FiDelete, FiCalendar } from "react-icons/fi";
import { groupsService } from "services";
import { errorFormating, hasSubscriptionFeature } from "utils/utils";
import { TwitterPicker } from 'react-color';
import SubmitButton from "components/SubmitButton";
import Switch from "components/Switch";
import GroupsMultiSelect from "components/Groups/GroupsMultiSelect";
import * as groupsActions from 'actions/groupsActions';
import moment from 'moment';
import UpgradeModal from 'components/Modal/UpgradeModal';
import InlineAlert from 'components/InlineAlert';
import { withTranslation } from 'react-i18next';


import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import es from "date-fns/locale/es"; // datepicker locale
registerLocale("es", es);

class GroupEdit extends React.Component {
	constructor(props) {
		super(props);
		// console.log(props);

		let group = {
			name: '',
			color: '',
			group_ids: [],
			is_multigroup: false,
			two_levels_workflow: false,
		}

		let isEdit = false;
		let selected_groups = [];

		if (props.group) {
			group = props.group;
			if (props.group.calendar)
				group.calendar_id = props.group.calendar.id;


			selected_groups = group.groups;
			isEdit = true;
		}

		this.state = {
			isEdit,
			isPickerVisible: false,
			isLoading: false,
			submitted: false,
			errors: {},
			group,
			selected_groups,
			new_item_error: false,
			showUpgradeModal: false,
			upgradeFeature: '',
		};
	}

	handleChange = event => {
		const { group } = this.state;

		const target = event.target.id;
		let value = event.target.value;

		if (target === "is_multigroup" || target === "two_levels_workflow") {
			value = event.target.checked;
			
			// Verificar si es el switch de two_levels_workflow y si tiene acceso
			if (target === "two_levels_workflow" && !hasSubscriptionFeature('TWO_LEVEL_APPROVAL')) {
				event.preventDefault();
				event.stopPropagation();
				// Forzar el checkbox a su estado anterior
				event.target.checked = group.two_levels_workflow;
				this.setState({
					showUpgradeModal: true,
					upgradeFeature: this.props.t('groups.form.twoLevelApproval')
				});
				return;
			}
		}

		if (target === "temp_group") {
			return;
		}

		// normal group change
		this.setState({
			group: {
				...group,
				[event.target.id]: value
			},
		});
	}

	handleSelectedGroupsChange = (ids) => {
		const idSet = new Set(ids.map(String));
		const selected_groups = (this.props.select_groups || []).filter((item) =>
			idSet.has(String(item.id))
		);

		this.setState({
			selected_groups,
			new_item_error: false,
		});
	}

	handleColorChange = ({ hex }) => {
		const { group } = this.state;

		if (hex === undefined)
			hex = '';

		this.setState({
			group: {
				...group,
				color: hex
			},
			isPickerVisible: false,
		});
	}

	handleDateChange = (id, date) => {
		const { group } = this.state;
		let key = id;
		// Si la fecha es null (el usuario ha eliminado la fecha), establece el valor en null o en una cadena vacía
		let value = date ? moment(date).format("YYYY-MM-DD") : null;

		this.setState({
			prevGroup: group,
			group: {
				...group,
				[key]: value,
			}
		});
	};

	checkValidField = (name) => {
		return (this.state.submitted && this.state.errors[name] !== undefined && this.state.errors[name] !== '');
	}

	handleSubmit = async event => {
		event.preventDefault();

		let response = '';
		const props = this.props;

		//console.log(this.state.group);
		const { selected_groups, group, new_item_error } = this.state;

		// validació si es multigrup i no hi ha grups
		if (group.is_multigroup && selected_groups.length == 0) {
			this.setState({
				submitted: true,
				new_item_error: true,
			});
		}
		else {
			this.setState({ isLoading: true });

			if (group.is_multigroup && selected_groups.length > 0)
				group.group_ids = selected_groups.map(group => group.id);
			else
				group.group_ids = [];


			// if edit => update; else => new
			if (this.state.isEdit) {
				response = await groupsService.update(group);
			}
			else {
				response = await groupsService.add(group);
			}

			//console.log(response);

			if (response.ok) {
				this.setState({
					isLoading: false,
					errors: {},
				}, () => {
					toastr.success(this.props.t('common.success'), this.props.t('common.changesSaved'));
					this.props.getAllGroups({ variant: 'detailed' });
					this.props.getChildGroups();
					this.props.getGroups();
					props.handleClose();
				});
			}
			else {
				this.setState({
					isLoading: false,
					submitted: true,
					errors: errorFormating(response)
				});
			}

		}


	}

	render() {
		const { group, errors, new_item_error, isEdit, selected_groups } = this.state;
		const { select_calendars, select_groups } = this.props;

		const optionCalendarList = select_calendars.length > 0 && select_calendars.map((item, i) => {
			return (
				<option key={item.id} value={item.id}>{item.name}</option>
			)
		}, this);

		const onToggleColorPicker = () => this.setState({ isPickerVisible: !this.state.isPickerVisible })
		const isMultigroup = group.is_multigroup;

		return (
			<>
			<form onSubmit={this.handleSubmit}>
				<div className="modal-body">
					<FormGroup className="form-group" controlId="name">
						<FormLabel>{this.props.t('common.name')} <span className="label-required">*</span></FormLabel>
						<FormControl
							type="text"
							value={group.name}
							onChange={this.handleChange}
							placeholder={this.props.t('groups.form.namePlaceholder')}
							isInvalid={this.checkValidField('name')}
						/>
						<FormControl.Feedback type="invalid">
							{errors.name}
						</FormControl.Feedback>
					</FormGroup>

					{(!isEdit) &&
						<FormGroup className="form-group form-group-flex form-group-main" controlId="is_multigroup">
							<FormLabel>{this.props.t('groups.form.multigroup')}</FormLabel>
							<Switch
								controlId="is_multigroup"
								isOn={isMultigroup}
								handleToggle={this.handleChange}
								disabled={isEdit}
							/>
							{isEdit && <span className='no-editable'>({this.props.t('groups.form.cannotEdit')})</span>}
						</FormGroup>
					}

				<FormGroup className="form-group form-group-flex form-group-main" controlId="two_levels_workflow">
					<div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
						<FormLabel style={{ flex: 1, opacity: !hasSubscriptionFeature('TWO_LEVEL_APPROVAL') ? 0.5 : 1 }}>
							{this.props.t('groups.form.secondLevelApproval')}
						</FormLabel>
						<Switch
							controlId="two_levels_workflow"
							isOn={group.two_levels_workflow}
							handleToggle={this.handleChange}
						/>
					</div>
				</FormGroup>


					<FormGroup className="form-group" controlId="calendar_id">
						<FormLabel>{this.props.t('groups.form.calendar')} <span className="label-required">*</span></FormLabel>
						<FormControl
							type="text"
							value={group.calendar_id}
							onChange={this.handleChange}
							isInvalid={this.checkValidField('calendar_id')}
							as="select">
							<option value="">{this.props.t('groups.form.selectCalendar')}</option>
							{optionCalendarList}
						</FormControl>

						<FormControl.Feedback type="invalid">
							{errors.calendar_id}
						</FormControl.Feedback>
					</FormGroup>

					<FormGroup controlId="color" className="form-group form-color">
						<div className="flex-between">
							<FormLabel>{this.props.t('groups.form.color')}</FormLabel>
							<FiDelete className={`icon-remove-color ${!group.color && 'hidden'} `} onClick={() => this.handleColorChange("")} />
						</div>
						<FormControl
							type="text"
							value={group.color}
							placeholder={this.props.t('groups.form.color')}
							readOnly
							isInvalid={this.checkValidField('color')}
							style={{ backgroundColor: group.color && group.color }}
							onClick={onToggleColorPicker}
						/>
						<FormControl.Feedback type="invalid">
							{this.state.errors.color}
						</FormControl.Feedback>

						<IoMdColorFill onClick={onToggleColorPicker} />

						{this.state.isPickerVisible && (
							<div style={{ position: 'absolute' }}>
								<TwitterPicker
									color={group.color ? group.color : '#ffffff'}
									onChangeComplete={(hex) => this.handleColorChange(hex)}
								/>
							</div>
						)}
					</FormGroup>

					{!isMultigroup &&
						<FormGroup controlId="published_until" className={`form-group form-date ${(group.published_until === '' || group.published_until === null) && 'empty'}  ${this.checkValidField('published_until') && "is-invalid"}`}>
							<FormLabel>{this.props.t('groups.form.publishedUntil')}</FormLabel>

							<DatePicker
								selected={group.published_until ? moment(group.published_until).toDate() : null}
								onChange={(date) => this.handleDateChange("published_until", date)}
								isInvalid={this.checkValidField("published_until")}
								className="form-control"
								dateFormat="dd/MM/yyyy"
								locale="es"
								placeholderText="dd/mm/aaaa"
							/>

							<FiCalendar />
							<FormControl.Feedback type="invalid">
								{errors.published_until}
							</FormControl.Feedback>
						</FormGroup>
					}


					{isMultigroup && (
						<FormGroup className="form-group" controlId="group_ids">
							<FormLabel>{this.props.t('groups.form.groups')}</FormLabel>
							<GroupsMultiSelect
								groups={select_groups}
								value={selected_groups.map((item) => item.id)}
								onChange={this.handleSelectedGroupsChange}
								isInvalid={new_item_error}
								controlId="group_ids"
							/>
						</FormGroup>
					)}

					{errors.general && (
						<InlineAlert variant="error" className="mt15">
							{errors.general}
						</InlineAlert>
					)}
				</div>

				<div className="modal-footer">
					<button type="button" onClick={this.props.handleClose} className="btn btn-outline-primary">{this.props.t('common.cancel')}</button>
					<SubmitButton
						type="submit"
						isLoading={this.state.isLoading}
						text={this.props.t('common.save')}
						loadingText={this.props.t('common.saving')}
					/>
				</div>
			</form>
			<UpgradeModal
				show={this.state.showUpgradeModal}
				onClose={() => this.setState({ showUpgradeModal: false })}
				feature={this.state.upgradeFeature}
				requiredPlan="Pro"
			/>
		</>
		)
	}
}


const mapStateToProps = (reducers) => {
	return {
		...reducers.calendarsReducer,
		...reducers.groupsReducer,
	}
};

export default connect(mapStateToProps, groupsActions)(withTranslation()(GroupEdit))
